// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._7wQ_KhraOD7XNV_7Gcnj4 {\n    width: 0;\n    margin: 8px 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: #373737;\n    box-sizing: border-box;\n    transition: .2s ease-out;\n  }\n    ._7wQ_KhraOD7XNV_7Gcnj4._1MlyHLj10SQkIHXsiINIx1 {\n      transition: .2s ease-out;\n      z-index: 100;\n    }\n  ._2I5tLfqZmuI4hmhaiAXBzH {\n    position: absolute;\n    top: 0;\n    left: -27px;\n    background: #373737;\n    color: white;\n    outline: none;\n    border: none;\n    font-size: 30px;\n    padding: 8px;\n    border-radius: 4px 0 0 4px;\n  }\n  .NsuFqULDSfAB5HIY7HbUg {\n    height: 97%;\n    overflow: scroll;\n    padding: 8px;\n  }\n", ""]);
// Exports
exports.locals = {
	"drawer": "_7wQ_KhraOD7XNV_7Gcnj4",
	"open": "_1MlyHLj10SQkIHXsiINIx1",
	"toggleButton": "_2I5tLfqZmuI4hmhaiAXBzH",
	"editors": "NsuFqULDSfAB5HIY7HbUg"
};
module.exports = exports;
